import { render } from "./EntityBadge.vue?vue&type=template&id=07807442&scoped=true"
import script from "./EntityBadge.vue?vue&type=script&lang=js"
export * from "./EntityBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07807442"]])

export default __exports__